import type { UmbracoRichText } from '@gro-up/types'

export function isUmbracoRichText(value: unknown): value is UmbracoRichText {
  return (
    typeof value === 'object' &&
    value !== null &&
    'tag' in value &&
    value.tag === '#root' &&
    'elements' in value &&
    Array.isArray(value.elements)
  )
}
